import React from 'react'
import { Fragment } from 'react'
import classes from './Header.module.css'

const Header = () => {
    return (
        <Fragment>


            <div className={classes.content}>
                <h2>MISS EARTH</h2>
                <h1>Global Beauty Pageant</h1>
                <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sit laboriosam earum cum, vel impedit consequuntur libero velit consectetur fuga repellat ullam, necessitatibus ipsam illo non expedita molestias quos numquam mollitia. Excepturi, quo dolorum ab eum sequi ipsa voluptatum dignissimos quam facilis deleniti molestias? Dicta, non!</p>
            </div>
        </Fragment >
    )
}

export default Header
